<template>
	<Col>
		<v-menu v-model="showMenu" :close-on-content-click="false" right nudge-right="210" nudge-top="51" transition="slide-x-transition">
			<template v-slot:activator="{ on, attrs }">
				<div @click="onActivatorClick" v-on="on" v-bind="attrs" class="display-flex flex-row flex-align-center width-100 pr-2">
					<Row class="activator flex-align-center width-100 px-1 flex-justify-space-between">
						<AppWorkspaceAvatar :account="activeAccount" />
						<v-icon class="chevron">mdi-chevron-right</v-icon>
					</Row>
				</div>
			</template>
			<WorkspaceSelectionMenu
				v-on="workspaceMenuHandlers"
				class="menu-content-container"
				:activeAccount="activeAccount"
				:joinedAccounts="joinedAccounts"
				:invitedAccounts="invitedAccounts"
			/>
		</v-menu>
	</Col>
</template>

<script>
import AppWorkspaceAvatar from '@/components/WorkspaceSelectionMenu/AppWorkspaceAvatar.vue';
import WorkspaceSelectionMenuMixin from '@/components/WorkspaceSelectionMenu/mixins/WorkspaceSelectionMenuMixin.js';

export default {
	name: 'WorkspaceSelectionMenuWrapper',
	components: { AppWorkspaceAvatar },
	mixins: [WorkspaceSelectionMenuMixin],
	methods: {
		onActivatorClick(e) {
			this.showMenu = true;
			e.stopPropagation();
		},
	},
};
</script>

<style scoped lang="scss">
$menu-width: 370px;
.activator {
	min-height: 30px;
	background: var(--bg-color);
	transition: var(--transition-time);
	&:hover {
		background: #f7f7f7;
		transition: var(--transition-time);
	}
}
.chevron {
	font-size: 12px;
	color: var(--primary-font-color);
}
.menu-content-container {
	width: $menu-width;
	min-width: $menu-width;
	max-width: $menu-width;
}
.avatar {
	font-size: 12px;
	min-width: 25px;
	min-height: 25px;
	font-weight: 500;
	border-radius: 50%;
	color: var(--white);
}
</style>
